import { dateFormatter } from "services/UtilityService";

function multiSelectIds(filtered, columnId) {
  const v = filtered.find((f) => f.id === columnId)?.value;
  if (!Array.isArray(v) || v.length === 0) return undefined;
  const ids = v
    .map((item) => (typeof item === "object" && item != null ? item.id : item))
    .filter((x) => x != null && String(x).trim() !== "");
  return ids.length ? ids : undefined;
}

function formatRangeDate(d) {
  if (!d) return undefined;
  return dateFormatter(d instanceof Date ? d : new Date(d));
}

/**
 * Maps react-table columnFilters to AI call log API fields.
 * @param {Array<{ id: string, value: unknown }>} filtered
 */
export function parseFilteredToApiParams(filtered) {
  const raw = (id) => filtered.find((f) => f.id === id)?.value;

  /** Exact match on `AiCallLogQueryRequestDto.switchInfoId`. */
  const switchInfoId = (() => {
    const v = raw("switchInfoIds");
    if (typeof v !== "string" || !v.trim()) return undefined;
    const trimmed = v.trim();
    if (!/^\d+$/.test(trimmed)) return undefined;
    return Number.parseInt(trimmed, 10);
  })();

  const callGroupTypes = multiSelectIds(filtered, "callGroupType");
  const outboundCallStatuses = multiSelectIds(filtered, "outboundCallStatus");
  const switchStatuses = multiSelectIds(filtered, "switchStatuses");
  const outcomeTags = multiSelectIds(filtered, "outcomeTags");

  const outboundPhoneSearch = (() => {
    const v = raw("outboundPhoneNumber");
    return typeof v === "string" && v.trim() ? v.trim() : undefined;
  })();

  const prescriberNpiSearch = (() => {
    const v = raw("prescriberNpi");
    return typeof v === "string" && v.trim() ? v.trim() : undefined;
  })();

  const cr = raw("creationTime");
  let creationDateFrom;
  let creationDateTo;
  if (Array.isArray(cr) && cr.length && cr[0]) {
    creationDateFrom = formatRangeDate(cr[0]);
    creationDateTo = formatRangeDate(cr[1] || cr[0]);
  }

  const ur = raw("updateTime");
  let updateDateFrom;
  let updateDateTo;
  if (Array.isArray(ur) && ur.length && ur[0]) {
    updateDateFrom = formatRangeDate(ur[0]);
    updateDateTo = formatRangeDate(ur[1] || ur[0]);
  }

  return {
    switchInfoId,
    callGroupTypes,
    outboundCallStatuses,
    switchStatuses,
    outcomeTags,
    outboundPhoneSearch,
    prescriberNpiSearch,
    creationDateFrom,
    creationDateTo,
    updateDateFrom,
    updateDateTo,
  };
}
